import { Box } from "@mui/material";
import { contentStyle } from "./styles";

const Content = ({ children }) => {
  return <Box sx={contentStyle()}>{children}</Box>;
};

export default Content;
